import { Component, OnInit, Input } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input('title') title: string;
  @Input('src') src: string;
  @Input('href') href: string;

  constructor() { }

  ngOnInit() {
  }

}
